import { render, staticRenderFns } from "./UsersCardLeftPanelGroups.vue?vue&type=template&id=1ab62061&"
import script from "./UsersCardLeftPanelGroups.vue?vue&type=script&lang=ts&"
export * from "./UsersCardLeftPanelGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports